(function() {
  'use strict';

  // Configure this URL when the backend is ready
  var RESTOCK_API_URL = 'https://ourhhaus-restock-api.vercel.app/api/restock-subscribe';

  function initWidget(widget) {
    var container = widget.closest('[data-section-id]');
    if (!container) return;

    var sectionId = container.getAttribute('data-section-id');
    var productJsonEl = document.getElementById('ProductJson-' + sectionId);
    if (!productJsonEl) return;

    var productJson = JSON.parse(productJsonEl.textContent);
    var productId = productJson.id;
    var productTitle = widget.getAttribute('data-product-title') || productJson.title;

    // Elements
    var triggerBtn = widget.querySelector('[data-restock-trigger]');
    var panel = widget.querySelector('[data-restock-panel]');
    var successEl = widget.querySelector('[data-restock-success]');
    // v2: SMS elements
    // var emailTab = widget.querySelector('[data-restock-tab="email"]');
    // var smsTab = widget.querySelector('[data-restock-tab="sms"]');
    // var emailField = widget.querySelector('[data-restock-email-field]');
    // var smsField = widget.querySelector('[data-restock-sms-field]');
    // var smsConsent = widget.querySelector('[data-restock-sms-consent]');
    // var phoneInput = widget.querySelector('[data-restock-phone]');
    // var countrySelect = widget.querySelector('[data-restock-country]');
    var emailInput = widget.querySelector('[data-restock-email]');
    var newsletterCheckbox = widget.querySelector('[data-restock-newsletter]');
    var submitBtn = widget.querySelector('[data-restock-submit]');
    var errorEl = widget.querySelector('[data-restock-error]');
    var variantNameEl = widget.querySelector('[data-restock-variant-name]');

    // -- Helpers --

    function getCurrentVariant() {
      var select = container.querySelector('#ProductSelect-' + sectionId);
      if (!select) return productJson.variants[0];
      var id = parseInt(select.value, 10);
      for (var i = 0; i < productJson.variants.length; i++) {
        if (productJson.variants[i].id === id) return productJson.variants[i];
      }
      return null;
    }

    function updateVariantName() {
      var variant = getCurrentVariant();
      if (variant && variantNameEl) {
        variantNameEl.textContent = variant.title;
      }
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.classList.remove('restock-widget__field--hidden');
    }

    function hideError() {
      errorEl.classList.add('restock-widget__field--hidden');
    }

    function resetWidget() {
      panel.classList.remove('restock-widget__panel--open');
      triggerBtn.classList.remove('restock-widget__field--hidden');
      successEl.classList.add('restock-widget__field--hidden');
      hideError();
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify Me';
    }

    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    // v2: SMS validation
    // function validatePhone(phone) {
    //   var digits = phone.replace(/\D/g, '');
    //   return digits.length === 10;
    // }

    // v2: close button
    // var closeBtn = widget.querySelector('[data-restock-close]');

    // -- Event handlers --

    // Expand panel
    triggerBtn.addEventListener('click', function() {
      panel.classList.add('restock-widget__panel--open');
      triggerBtn.classList.add('restock-widget__field--hidden');
      updateVariantName();
      emailInput.focus();
    });

    // v2: close button handler
    // closeBtn.addEventListener('click', function() {
    //   panel.classList.remove('restock-widget__panel--open');
    //   triggerBtn.classList.remove('restock-widget__field--hidden');
    //   hideError();
    // });

    // v2: SMS/Email tab handlers
    // emailTab.addEventListener('click', function() {
    //   currentChannel = 'email';
    //   emailTab.classList.add('restock-widget__tab--active');
    //   smsTab.classList.remove('restock-widget__tab--active');
    //   emailField.classList.remove('restock-widget__field--hidden');
    //   smsField.classList.add('restock-widget__field--hidden');
    //   smsConsent.classList.add('restock-widget__field--hidden');
    //   submitBtn.textContent = 'Notify Me';
    //   hideError();
    //   emailInput.focus();
    // });
    // smsTab.addEventListener('click', function() {
    //   currentChannel = 'sms';
    //   smsTab.classList.add('restock-widget__tab--active');
    //   emailTab.classList.remove('restock-widget__tab--active');
    //   emailField.classList.add('restock-widget__field--hidden');
    //   smsField.classList.remove('restock-widget__field--hidden');
    //   smsConsent.classList.remove('restock-widget__field--hidden');
    //   submitBtn.textContent = "Text Me When It's Back";
    //   hideError();
    //   phoneInput.focus();
    // });

    // Submit
    submitBtn.addEventListener('click', function() {
      hideError();

      var variant = getCurrentVariant();
      if (!variant) {
        showError('Please select a variant.');
        return;
      }

      var email = emailInput.value.trim();
      if (!validateEmail(email)) {
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      var payload = {
        product_id: productId,
        variant_id: variant.id,
        product_title: productTitle,
        variant_title: variant.title,
        channel: 'email',
        contact: email,
        newsletter_opt_in: newsletterCheckbox.checked,
        source_url: window.location.href
      };

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      fetch(RESTOCK_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Request failed');
          return response.json();
        })
        .then(function() {
          panel.classList.remove('restock-widget__panel--open');
          updateVariantName();
          successEl.classList.remove('restock-widget__field--hidden');
        })
        .catch(function() {
          showError('Something went wrong. Please try again.');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify Me';
        });
    });

    // Allow submit on Enter key
    emailInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') submitBtn.click();
    });
    // v2: SMS enter key handler
    // phoneInput.addEventListener('keydown', function(e) {
    //   if (e.key === 'Enter') submitBtn.click();
    // });

    // Watch for variant changes via the hidden select
    var variantSelect = container.querySelector('#ProductSelect-' + sectionId);
    if (variantSelect) {
      var selectObserver = new MutationObserver(function() {
        updateVariantName();
        // Reset to trigger button state when variant changes
        var form = container.querySelector('form[data-product-form]');
        if (form && !form.classList.contains('product-form--variant-sold-out')) {
          resetWidget();
        }
      });
      selectObserver.observe(variantSelect, { childList: true, attributes: true, subtree: true });

      // Also watch for the form class change (in-stock ↔ sold-out)
      var form = container.querySelector('form[data-product-form]');
      if (form) {
        var formObserver = new MutationObserver(function() {
          if (!form.classList.contains('product-form--variant-sold-out')) {
            resetWidget();
          } else {
            updateVariantName();
          }
        });
        formObserver.observe(form, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  // Initialize all widgets on the page
  document.addEventListener('DOMContentLoaded', function() {
    var widgets = document.querySelectorAll('[data-restock-widget]');
    for (var i = 0; i < widgets.length; i++) {
      initWidget(widgets[i]);
    }
  });
})();
